export enum EOnBoardingStatusEnum {
    NotMentioned = 0,

    Sandbox = 2,

    ApplicationPending = 4,

    Approved = 5
}